import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import Control from 'components/Control/Control';
import Label from 'components/Label/Label';
import Button from 'components/Button';
import PersonalInfo from 'modules/Onboarding/Register/PersonalInfoNew';
import Education from 'modules/Onboarding/Register/EducationNew';
import ProjectInternship from 'modules/Onboarding/Register/ProjectInternshipNew';
import WorkExperience from 'modules/Onboarding/Register/WorkExperienceNew';
import AntdSteps from 'components/AntdSteps';
import { CurrentCourseWrapper } from './style';
import { useSelector, useDispatch } from 'react-redux';
import { getPendingData } from 'modules/Resume/actions';
const TabContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #E1E1E1;
  padding-bottom: 10px;
`;

const TabItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 20px;
  background: ${props => props.active ? '#E1FBF1' : 'transparent'};

  .icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.active ? '#00A94F' : '#E1E1E1'};
    color: ${props => props.active ? '#FFFFFF' : '#666666'};
  }

  .text {
    color: ${props => props.active ? '#00A94F' : '#666666'};
    font-weight: ${props => props.active ? '600' : '400'};
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 20px;
    padding: 24px 24px 0px 24px;
    height: 100vh;
  }
  .ant-modal-body {
    padding: 24px 0;
  }
  .form-content {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    padding-right: 16px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }
  }
  .fixed-footer {
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #E1E1E1;
  }

  `;

const InfoText = styled.div`
  padding: 12px;
  background: #F5F5F5;
  border-radius: 10px;
  margin-bottom: 24px;
  text-align: center;
  color: #666666;
`;

const tabs = [
  { id: 'personal', label: 'Personal Details', step: 1, activeKey: 1, title: 'Personal Details' },
  { id: 'education', label: 'Educational Details', step: 2, activeKey: 2, title: 'Educational Details' },
  { id: 'project', label: 'Project & Internship', step: 3, activeKey: 3, title: 'Project & Internship' },
  { id: 'work', label: 'Work Experience', step: 4, activeKey: 4, title: 'Work Experience' }
];

const PopModal = ({ 
  visible, 
  onClose,
  studentData,
  studentFormData,
  getStudentData,
  updateStudentData,
  deleteFile,
  instituteDeatils,
  deleteEducation,
  getCollege,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  countryList,
  stateList,
  updateStatusPending,
  getFunctionsList,
  getDesignationsList,
  getIndustryList,
  updateCurrentState,
  getListOfSkills,
  getSkillList,
  updateCvDetails,
  getCorporateList,
  searchAPI,
  updateUserProfile,
  onStartCvUpload = () => {},
  onCvProgress = () => {},
  onFinishCvUpload = () => {},
  cvDetails,
  getCities,
  setModalVisibleData
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('personal');
  const pendingData = useSelector(state => state?.resumeData?.pendingData);
  const studentId = useSelector(state => state?.resumeData?.studentFormData?.student?.id);
  
  useEffect(() => {
    if (visible) {
      dispatch(getPendingData());
     getStudentData()
    }
  }, [visible,activeTab]);
  
  // Reset to the first tab (personal) whenever the modal becomes visible
  useEffect(() => {
    if (visible) {
      setActiveTab('personal');
    }
  }, [visible]);
  
  // Use ref instead of state for form references to prevent infinite update loops
  const formRefs = useRef({});
  
  // Define the stepper tabs with their IDs and labels
  const tabs = [
    {
      title: 'Personal Info',
      id: 'personal',
      activeKey: 0
    },
    {
      title: 'Education',
      id: 'education',
      activeKey: 1
    },
    {
      title: 'Project/Internship',
      id: 'project',
      activeKey: 2
    },
    {
      title: 'Work Experience',
      id: 'work',
      activeKey: 3
    },
  ];
  
  // Function to register form reference from child components
  const registerForm = (tabId, formInstance) => {
    // Update the ref directly instead of using state setter
    // formRefs.current = {
    //   ...formRefs.current,
    //   [tabId]: formInstance
    // };
  };

  // Function to handle step click with validation
  const handleStepClick = async (current) => {
    // Convert from number to the tab ID
    const currentTabId = tabs[current]?.id;
    if (!currentTabId) return;
    
    // Find which tab we're currently on and which one we're going to
    const currentTabIndex = tabs.findIndex(tab => tab.id === activeTab);
    
    // Only allow navigation to adjacent steps (prevent skipping)
    if (Math.abs(current - currentTabIndex) > 1) {
      console.log('Cannot skip steps. Please complete each step in sequence.');
      return;
    }
    
    // Allow moving backward without validation
    if (current < currentTabIndex) {
      setActiveTab(currentTabId);
      return;
    }
    
    // If moving forward or to another tab that requires validation and submission
    const currentFormRef = formRefs.current[activeTab];
    if (currentFormRef) {
      try {
        // First validate the current form
        await currentFormRef.validateFields();
        
        // Submit the form directly using Ant Design's form submit method
        // This will trigger the onFinish handler in the form component
        await currentFormRef.submit();
        
        // Form is valid and submitted, allow navigation
        setActiveTab(currentTabId);
      } catch (error) {
        // Form has validation errors, stay on current tab
        console.log('Validation failed:', error);
      }
    } else {
      // If no form reference, allow navigation
      setActiveTab(currentTabId);
    }
  };
  
  const renderContent = () => {
    const commonProps = {
      studentData,
      studentFormData,
      getStudentData,
      updateStudentData,
      deleteFile,
      instituteDeatils,
      deleteEducation,
      getCollege,
      getListOfCountries,
      getListOfState,
      getListOfCity,
      countryList,
      stateList,
      updateStatusPending,
      getFunctionsList,
      getDesignationsList,
      getIndustryList,
      updateCurrentState,
      getListOfSkills,
      getSkillList,
      updateCvDetails,
      getCorporateList,
      searchAPI,
      updateUserProfile,
      setActiveTab,
      onStartCvUpload,
      onCvProgress,
      onFinishCvUpload,
      cvDetails,
      getCities,
      setModalVisibleData,
      registerForm,
      pendingData
    };

    switch (activeTab) {
      case 'personal':
        return <PersonalInfo {...commonProps} />;
      case 'education':
        return <Education {...commonProps} />;
      case 'project':
        return <ProjectInternship {...commonProps} />;
      case 'work':
        return <WorkExperience {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <StyledModal
      visible={visible}
      width="80%"
      centered
      maskClosable={false}
      footer={null}
      closable={true}
      onCancel={onClose}
    >
      <CurrentCourseWrapper>
        To apply for jobs, make sure to fill these fields.
      </CurrentCourseWrapper>

      <AntdSteps 
        style={{ padding: '20px' }}
        direction="horizontal"
        steps={tabs} 
        current={tabs.findIndex(tab => tab.id === activeTab)}
      //  onChange={handleStepClick}
      />
 
      <div className="form-content">
        {renderContent()}
      </div>

      {/* <div className="fixed-footer">
        <Control row gap="10px" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <Button.Secondary text="Back" onClick={onClose} />
          <Button.Primary
            text="Next"
            
            onClick={() => {
              const currentIndex = tabs.findIndex(tab => tab.id === activeTab);
              if (currentIndex < tabs.length - 1) {
                setActiveTab(tabs[currentIndex + 1].id);
              }
            }}
          />
        </Control>
      </div> */}
    </StyledModal>
  );
};

export default PopModal;
